import { render, staticRenderFns } from "./dfm-ir-app.vue?vue&type=template&id=8db3dbd8"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CImage: require('/vercel/path0/components/ui/c-image.vue').default,AppStoreLinks: require('/vercel/path0/components/blocks/AppStoreLinks.vue').default})
